import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DesignSidebar from 'src/components/DesignSidebar/DesignSidebar';
import HvSvg from 'src/components/HvSvg';
import MeasureSidebar from 'src/components/MeasureSidebar/MeasureSidebar';
import constants from 'src/constants';
import uiDux from 'src/redux/ui';
import utils from 'src/utils';
import { CloseSidebarButton, SidebarContainer } from './styled';

const { MODE_NAMES } = constants.app;

const mapStateToProps = (state) => ({
  activeMode: state.designPro.app.activeMode,
  isOpen: state.designPro.ui.isSidebarOpen,
  isSidebarCloseButtonVisible: uiDux.selectors.isSidebarCloseButtonVisible(
    state,
  ),
  canRequestRendering:
    state.designPro.app.jobDetails.can_request_hi_def_rendering,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleSidebarCloseClick: uiDux.actions.handleSidebarCloseClick,
    },
    dispatch,
  );

export class Sidebar extends PureComponent {
  static propTypes = {
    activeMode: PropTypes.string,
    handleSidebarCloseClick: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    isSidebarCloseButtonVisible: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    activeMode: null,
    isOpen: false,
  };

  renderSidebarComponent() {
    const { activeMode } = this.props;

    switch (activeMode) {
      case MODE_NAMES.DESIGN:
        return <DesignSidebar />;
      case MODE_NAMES.MEASURE:
        return <MeasureSidebar />;
      default:
        return null;
    }
  }

  render() {
    const {
      handleSidebarCloseClick,
      isOpen,
      isSidebarCloseButtonVisible,
    } = this.props;

    return (
      <SidebarContainer
        isOpen={isOpen}
        id="sidebar-root"
        data-selenium="sidebar"
      >
        {isOpen && (
          <CloseSidebarButton
            isSidebarCloseButtonVisible={isSidebarCloseButtonVisible}
            onClick={handleSidebarCloseClick}
            data-selenium="closeSidebarButton"
          >
            <HvSvg
              src={require('src/assets/images/small-triangle.svg')}
              disabled={false}
            />
          </CloseSidebarButton>
        )}
        {this.renderSidebarComponent()}
      </SidebarContainer>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
